export const LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE = 'LINEKDIN_SELECT_MESSAGE_TEMPLATE_STATE';
export const LINEKDIN_SUMMARY_TEMPLATE_STATE = 'LINEKDIN_SUMMARY_TEMPLATE_STATE';
